import { useMutation } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

export interface SendTicketsRequest {
  parentIds: Array<string>;
  integrationId: string;
}

export interface SendTicketsError {
  parentId: string;
  error: string;
}

export interface SendTicketsResponse {
  success: boolean;
  sent: number;
  failed: number;
  errors: Array<SendTicketsError>;
}

export const sendTicketsAPI = async (
  params: SendTicketsRequest,
): Promise<SendTicketsResponse> => {
  const response = await baseAPI.post<SendTicketsResponse>(
    '/api/admin/drt/send-tickets',
    params,
  );
  return response.data;
};

export const useSendTicketsMutation = () => {
  return useMutation({
    mutationFn: sendTicketsAPI,
  });
};
